import { render } from "./SVGLogo.vue?vue&type=template&id=4ae43eb4"
import script from "./SVGLogo.vue?vue&type=script&lang=js"
export * from "./SVGLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__